var React = require('react');

function IconContact (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("g",{"id":"Envelope"},[React.createElement("path",{"d":"m26.47,26.49H6.32c-3.49,0-6.32-2.84-6.32-6.32V6.32C0,2.84,2.84,0,6.32,0h20.15c3.49,0,6.32,2.84,6.32,6.32v13.84c0,3.49-2.84,6.32-6.32,6.32ZM6.32,2.5c-2.11,0-3.82,1.71-3.82,3.82v13.84c0,2.11,1.71,3.82,3.82,3.82h20.15c2.11,0,3.82-1.71,3.82-3.82V6.32c0-2.11-1.71-3.82-3.82-3.82H6.32Z","fill":"#f45858","key":0}),React.createElement("path",{"d":"m16.4,17.04L5.25,6.03c-.49-.48-.5-1.28-.01-1.77.48-.49,1.28-.5,1.77-.01l9.38,9.27,9.38-9.27c.49-.49,1.28-.48,1.77.01.48.49.48,1.28-.01,1.77l-11.14,11Z","fill":"#f45858","key":1})])));
}

IconContact.defaultProps = {"id":"Layer_2","data-name":"Layer 2","viewBox":"0 0 32.79 26.49"};

module.exports = IconContact;

IconContact.default = IconContact;
